import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_jewelry_new_brands: FaireCategoryEntity = {
  token: "cat_jewelry-new-brands",
  type: "category",
  name: "New brands",
  level: 2,
  parentToken: "cat_jewelry",
  href: "/category/jewelry/new-brands",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
